import React from 'react'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'

export const deleteAttackEventTagMutation = gql`
  mutation DeleteAttackEventTag(
    $organizationID: ID!
    $eventUuid: ID!
    $tag: String!
  ) {
    deleteAttackEventTag(
      input: {
        organizationID: $organizationID
        eventUuid: $eventUuid
        tag: $tag
      }
    ) {
      _placeholder
    }
  }
`

export function DeleteAttackEventTagMutation({
  organizationID,
  children
}: {
  readonly organizationID: string
  readonly children: (
    fn: (props: {
      readonly tag: string
      readonly eventUuid: string
    }) => Promise<any>
  ) => any
}) {
  return (
    <Mutation mutation={deleteAttackEventTagMutation}>
      {(deleteAttackEventTag) =>
        children(({ eventUuid, tag }) =>
          deleteAttackEventTag({
            variables: {
              organizationID,
              eventUuid,
              tag
            }
          })
        )
      }
    </Mutation>
  )
}
